import React from "react";

import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";

import { LinkButton } from "components/Form";

import { CriteriaForm } from "containers/Settings/RuleBooks/Rules/CustomRules/Criteria/CriteriaForm";

interface RuleSetSummaryProps {
  openEditSettings: () => void;
  readOnly: boolean;
}

interface FormValues {
  name: string;
}

export const RuleSetSummary = ({
  openEditSettings,
  readOnly,
}: RuleSetSummaryProps) => {
  const {
    values: { name },
  } = useFormikContext<FormValues>();

  return (
    <Grid container>
      <Grid item xs={12} style={{ overflow: "hidden" }}>
        <Grid
          item
          xs={12}
          style={{
            minHeight: "116px",
            maxHeight: "350px",
            overflowY: "auto",
            overflowX: "clip",
          }}
        >
          <Grid item xs={12}>
            <h2 className="leading-none">{name}</h2>
          </Grid>
          <Grid container>
            <CriteriaForm
              parentInputPath={null}
              hasPrerequisiteRule={false}
              readOnly
            />
          </Grid>
        </Grid>
        <br />
        <Grid container>
          {!readOnly && (
            <Grid item xs={4}>
              <LinkButton onClick={openEditSettings}>Edit Rule Set</LinkButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
